import { useRouter } from 'expo-router';
import { useEffect, useState } from 'react';
import Modal from 'react-native-modal';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Button, Card, Text } from '@/ui';

type SubscriptionCancelTripModalProps = {
  visible: boolean;
  onClose: () => void;
};

export function SubscriptionCancelTripModal({
  visible,
  onClose,
}: SubscriptionCancelTripModalProps) {
  const { styles } = useStyles(stylesheet);
  const router = useRouter();
  const [open, setOpen] = useState(visible);

  useEffect(() => {
    setOpen(visible);
  }, [visible]);

  if (!open) return null;

  return (
    <Modal
      animationIn="slideInUp"
      animationInTiming={300}
      animationOut="slideOutDown"
      animationOutTiming={1000}
      isVisible={open}
      hasBackdrop
      style={{
        ...styles.container,
      }}
      onBackdropPress={() => {
        setOpen(false);
        onClose();
      }}
      onDismiss={() => {
        setOpen(false);
        onClose();
      }}
    >
      <Card style={{ gap: 32, padding: 16 }}>
        <Text type="title2">Cancel Your Subscription?</Text>

        <Text type="bodyRegular">
          We handle cancellations through support so we can confirm your account
          and process any refund.
        </Text>

        <Button
          type="primary"
          onPress={() => {
            router.push('/account/support-faq');
            onClose();
          }}
          text="Contact Support"
        />
      </Card>
    </Modal>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    margin: 0,
    alignSelf: 'center',
    maxWidth: {
      xs: '95%',
      sm: 600,
    },
    width: {
      xs: '95%',
      md: 600,
    },
  },
}));
